import type React from "react";
import { Box } from "@salestrak/ui";

import { IssueCard } from "#app/components/issue-card";
import type { MapIssue } from "./map-issue";

export function MapIssueCard({
  issue,
  onClick,
}: {
  issue: MapIssue;
  onClick: (issue: MapIssue) => void;
}) {
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    // React portal events still bubble through their logical tree. Ignore
    // menu and picker popup presses whose DOM node is outside this card.
    if (!event.currentTarget.contains(event.target as Node)) return;
    onClick(issue);
  };

  return (
    <Box onClick={handleClick}>
      {/* The board's kanban card, re-grounded for its host: same rungs, same
          anatomy; `surface="popover"` recesses the dark fill to the page rung
          (the card token is within half a step of the popover and vanished),
          and `pressable` makes the whole card the press target. */}
      <IssueCard issue={issue} pressable surface="popover" />
    </Box>
  );
}
